import type { ReactNode } from 'react';

import * as styles from './DropdownHeading.css';

interface NavHeadingProps {
  children: ReactNode;
}

export const NavHeading = ({ children }: NavHeadingProps) => (
  <h3 className={styles.dropdownHeading}>{children}</h3>
);
